export default __webpack_public_path__ + "static/media/helpful-resources-page--tablet.9083afb7.jpg";